interface Props { actorId: string; actorScope: string; organisationId: string; allowed: boolean; onMutationStateChange: (pending: boolean) => void; onPublicationChange: () => void }

/** Compatibility wrapper for the retired per-school preference. */
export default function ExtraSurveyWavesSettings({ allowed }: Props) {
  if (!allowed) return null;
  return <div className="border-t border-pd-rule pt-4 text-sm text-pd-ink">
    <h3 className="font-semibold">Survey schedule</h3>
    <p className="mt-2 text-xs text-pd-slate">When surveys are available for a school, follow-ups are invited 3, 6 and 12 months from each person's first course start, or school activation if they had already started. Only the latest due check-in is invited. They do not block courses or repeat automatically.</p>
  </div>;
}
